import { useQuery, ApolloError } from '@apollo/client'

import { PROJECTS, PROJECTS_AS_ADMIN } from '@libs/apollo/queries'

import { QueryProjectsArgs, Project } from '@types'

import { useAppState } from '../app/app-state.hook'

interface Data {
  projects?: Project[]
  sharedProjects?: Project[]
}

export const useProjects = (): {
  loading: boolean
  error: ApolloError | undefined
  refetch: () => void
  data?: Data
} => {
  const { getOrganization } = useAppState()
  const organization = getOrganization()

  const { loading, error, data, refetch } = useQuery<Data, QueryProjectsArgs>(PROJECTS, {
    variables: {
      input: {
        organizationId: organization.id,
      },
    },
    notifyOnNetworkStatusChange: true,
  })

  const refetchData = () => {
    const variables: QueryProjectsArgs = {
      input: {
        organizationId: organization.id,
      },
    }
    refetch(variables)
  }

  return { loading, error, data, refetch: refetchData }
}

interface DataAsAdmin {
  adminFindProjects: Project[]
}

export const useProjectsAsAdmin = (): {
  loading: boolean
  error: ApolloError | undefined
  refetch: () => void
  data?: DataAsAdmin
} => {
  const { loading, error, data, refetch } = useQuery<DataAsAdmin>(PROJECTS_AS_ADMIN, {
    notifyOnNetworkStatusChange: true,
  })

  const refetchData = () => {
    refetch()
  }

  return { loading, error, data, refetch: refetchData }
}
